import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = "/procure-logo.webp";

export const api = axios.create({ baseURL: API, withCredentials: true });

// The office can read a customer's portal from their job (/portal?preview_customer=…). Every
// portal request made from inside that preview names the customer being previewed, so the screen
// can never mix their records with the signed-in member of staff's own.
api.interceptors.request.use((config) => {
  const previewCustomer = new URLSearchParams(window.location.search).get("preview_customer");
  if (previewCustomer && String(config.url || "").startsWith("/portal")) {
    config.params = { ...(config.params || {}), preview_customer: previewCustomer };
  }
  return config;
});

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return error?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (value) =>
  typeof value === "number"
    ? value.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 2 })
    : "—";

export const shortDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export async function uploadFiles(files, kind = "photo", category = "") {
  const form = new FormData();
  Array.from(files).forEach((file) => form.append("files", file));
  form.append("kind", kind);
  form.append("category", category);
  const { data } = await api.post("/uploads", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.files;
}
